import React from 'react';
import { times } from 'lodash';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Card } from '../../../../../../CommonComponents/OPL/Card/Card';
import { HtmlTable } from '../../../../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { Shimmer } from '../../../../../../CommonComponents/OPL/Shimmer/Shimmer';
import { LegendRow, StatsRow } from './components/ScenarioProjection/ScenarioProjection.styles';
import { SplineChartLoading } from '../../../../../../CommonComponents/OPL/charts/SplineChart/SplineChart.loading';

const LEGEND_LINE_WIDTHS = [180, 200, 140, 170];

export const MarketScenariosLoading = () => {
  return (
    <Box>
      <Box display="flex" alignItems="center" mb="24">
        <Shimmer height={20} width="100%" maxWidth="560px" mr="8" />
        <Shimmer width={16} height={16} isRound flexShrink={0} />
      </Box>

      <Box display="flex" flexDirection="column" css={({ theme }) => ({ gap: theme.space['24'] })}>
        <Card p="24" hasBorder>
          <Shimmer height={24} width={280} mb="16" />

          <SplineChartLoading />

          <LegendRow>
            {LEGEND_LINE_WIDTHS.map((w, i) => (
              <Box
                key={i}
                display="flex"
                alignItems="center"
                css={({ theme }) => ({ gap: theme.space['8'] })}
              >
                <Shimmer width={12} height={12} />
                <Shimmer height={16} width={w} />
              </Box>
            ))}
          </LegendRow>

          <Box mt="24">
            <Shimmer height={16} width={260} mb="8" />
            <StatsRow>
              {times(4).map((_, i) => (
                <Box
                  key={i}
                  flex={1}
                  display="flex"
                  alignItems="flex-start"
                  css={({ theme }) => ({
                    padding: `${theme.space['12']}px ${theme.space['16']}px`,
                  })}
                >
                  <Shimmer width={4} height={44} mr="12" flexShrink={0} />
                  <Box flex={1} minWidth={0}>
                    <Shimmer height={16} width="72%" mb="4" />
                    <Shimmer height={28} width="88%" />
                  </Box>
                </Box>
              ))}
            </StatsRow>
          </Box>
        </Card>

        <Card p="24" hasBorder>
          <Shimmer height={24} width={240} mb="16" />
          <Shimmer height={18} width="100%" maxWidth="640px" mb="8" />
          <Shimmer height={18} width="100%" maxWidth="520px" mb="24" />

          <HtmlTable variant="bordered" maxHeight={600} width="100%" fixedHead>
            <table style={{ tableLayout: 'fixed', width: '100%' }}>
              <colgroup>
                <col width="10%" />
                <col width="20%" />
                <col />
                <col />
                <col />
                <col />
              </colgroup>
              <thead>
                <tr>
                  {times(6).map(key => (
                    <th key={key}>
                      <Shimmer height={18} width={key === 1 ? '90%' : '70%'} />
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {times(8).map(rowKey => (
                  <tr key={rowKey}>
                    {times(6).map(cellKey => (
                      <td key={cellKey}>
                        <Shimmer width="100%" height={24} />
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </HtmlTable>
        </Card>
      </Box>
    </Box>
  );
};
